<!--
 * @Author: your name
 * @Date: 2020-11-03 16:11:00
 * @LastEditTime: 2021-03-22 14:59:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\Info.vue
-->
<template>
  <div id='info'>
    <el-row class="admin_content">
      <el-row class="backHome">
        <span @click="goBackHome"><img src="@/assets/img/返回.png" alt=""> 返回首页</span>
      </el-row>
      <template v-if="roleType==3">
        <el-row class="detailInfo uploadImg">
          <!-- <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName"> -->

          <el-upload :limit="100" :action="imageUrl" :on-success="handleSuccess" :on-preview="handlePreview" :on-remove="handleRemove" list-type="picture" :headers="headerObj" :before-upload="beforeAvatarUpload">
            <el-avatar shape="square" v-if="userInfo.logo==''||userInfo.logo==null||userInfo.logo.length==1" class="defaultImg1" >{{memberInfo.memberUnitName.substr(0,1)}}</el-avatar>
            <el-avatar shape="square" v-else :src="userInfo.logo" fit="contain" class="defaultImg"></el-avatar>
            <div class="upload">
              <span class="button add" @click="uploadFile">上传公司LOGO</span>
              <!-- <span slot="tip" class="el-upload__tip tips">只能上传jpg/png图片，且不超过500kb</span> -->
            </div>
          </el-upload>
        </el-row>
        <!-- <el-divider></el-divider> -->
      </template>
      <el-row class="detailInfo">
        <template v-if="roleType==2 &&userInfo">
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">账号名</el-col>
          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="titleContent">{{userInfo.userName}}</el-col>
        </template>
        <template v-if="roleType==3 &&memberInfo">
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">公司名</el-col>
          <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19" class="titleContent">{{memberInfo.memberUnitName}}</el-col>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <img src="@/assets/img/编辑.png" alt="" @click="companyNameVisible=true">
          </el-col>
        </template>
      </el-row>
      <el-divider></el-divider>
      <template v-if="roleType==3">
        <el-row class="detailInfo">
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">基本信息</el-col>
          <el-col v-if="userInfo" :xs="20" :sm="20" :md="20" :lg="20" :xl="20" :class="meberImperfectNum == 0?'titleContent strong':'titleContent warning'">{{meberImperfectNum == 0?'已完善':'未完善'}}</el-col>
        </el-row>
        <el-divider></el-divider>
      </template>
      <template v-if="roleType==2">
        <el-row class="detailInfo">
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">人员编号</el-col>
          <el-col v-if="userInfo" :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="titleContent">{{userInfo.personNo}}</el-col>
        </el-row>
        <el-divider></el-divider>
      </template>
      <el-row class="detailInfo">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">
          账号密码
        </el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19" v-if="userInfo" class="titleContent">
          当前密码强度：<span class="strong">强</span>
        </el-col>
        <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
          <img src="@/assets/img/编辑.png" alt="" @click="passwordVisible=true">
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="detailInfo" v-if="email!='wwj13012021@163.com'&&email!='wwj1301@126.com'">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">
          登录邮箱、消息接收邮箱
        </el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19" v-if="userInfo" class="titleContent">
          已绑定邮箱:{{ userInfo.email.substr(0, 3) + '****' + userInfo.email.substr(7)}},可用于重置密码和接收重要通知
        </el-col>
        <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
          <img src="@/assets/img/编辑.png" alt="" @click="editEmailInfo">
        </el-col>
      </el-row>
      <el-divider v-if="email!='wwj13012021@163.com'&&email!='wwj1301@126.com'"></el-divider>
    </el-row>

    <!-- 修改公司名 -->
    <el-dialog title="修改公司名" :visible.sync="companyNameVisible" width="25%" custom-class="editPasswrd" @close="closeEditNameDialog">
      <el-form :model="editCompanyNameForm" status-icon :rules="editCompanyNameRules" ref="editCompanyNameForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="新公司名" prop="newCompanyName">
          <el-input placeholder="请输入新公司名" v-model="editCompanyNameForm.newCompanyName"></el-input>
        </el-form-item>
        
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="userInfo">
        <el-button type="primary" @click="holdNewCompanyName()" class="button add" >保存</el-button>
        <el-button @click="companyNameVisible=false" class="button cancel">取 消</el-button>
      </span>

    </el-dialog>
    
    <!-- 修改密码弹框 -->
    <el-dialog title="修改登录密码" :visible.sync="passwordVisible" width="25%" custom-class="editPasswrd" @close="closeEditDialog">
      <el-form :model="editPasswordRuleForm" status-icon :rules="editPasswordRules" ref="editPasswordRuleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" placeholder="请输入旧密码" show-password v-model="editPasswordRuleForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" placeholder="请输入新密码" show-password v-model="editPasswordRuleForm.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="再次确认密码" prop="checkPass">
          <el-input type="password" placeholder="请再次确认密码" show-password v-model="editPasswordRuleForm.checkPass"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="userInfo">
        <el-button type="primary" @click="holdNewPassword(5,userInfo.userId)" class="button add" v-if="roleType==3">保存</el-button>
        <el-button type="primary" @click="holdNewPassword(5,userInfo.id)" class="button add" v-else>保存</el-button>
        <el-button @click="passwordVisible=false" class="button cancel">取 消</el-button>
      </span>

    </el-dialog>

    <!-- 更改绑定邮箱 -->
    <el-dialog title="更改绑定邮箱" :visible.sync="editInfoVisible" width="35%" custom-class="editInfoVisible" @close="closeeditInfoDialog">
      <el-steps :active="stepActive" v-if="stepActive==0 ||stepActive==1" space="200px" :align-center="true">
        <el-step title="验证账号"></el-step>
        <el-step title="变更信息"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <el-divider v-if="stepActive==0 ||stepActive==1"></el-divider>
      <el-form :model="editInfoForm" status-icon :rules="editInfoRules" ref="editInfoForm" label-width="160px" class="editInfoForm editPassward" v-if="stepActive==0">
        <el-form-item label="当前邮箱" prop="email" v-if="userInfo">
          {{userInfo.email}}
          <el-button :disabled="isDisable" type="primary" @click="sendCode(userInfo.email)" class="button send">{{isDisable?`${time}s`:'获取验证码'}}</el-button>
        </el-form-item>
        <el-form-item label="验证码" prop="code" class="code">
          <el-input type="password" placeholder="请输入验证码" v-model="editInfoForm.captcha"></el-input>
        </el-form-item>
      </el-form>
      <el-form :model="newEmailForm" status-icon :rules="newEmailRules" ref="newEmailForm" label-width="90px" class="editInfoForm newEmailForm" v-if="stepActive==1">
        <el-form-item label="新邮箱" prop="newEmail">
          <el-input auto-complete="new-password" class="newEmail" placeholder="请输入新邮箱" v-model="newEmailForm.newEmail"></el-input>
          <el-button type="primary" :disabled="isDisable" @click="sendCode(newEmailForm.newEmail)" class="button send">{{isDisable?`${time}s`:'获取验证码'}}</el-button>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha" class="code">
          <el-input auto-complete="new-password" type="password" placeholder="请输入验证码" v-model="newEmailForm.captcha"></el-input>
        </el-form-item>
      </el-form>
      <el-row v-if="stepActive==2" style="text-align:center;">
        <img src="@/assets/img/修改成功.png" alt="">
        <p>修改成功!</p>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="stepActive==0" type="primary" @click="next" class="button">下一步</el-button>
        <el-button v-if="stepActive==1" type="primary" @click="stepActive=0" class="button">上一步</el-button>
        <el-button v-if="stepActive==1" type="primary" @click="nextStep" class="button nextSure">确定</el-button>
        <el-button v-if="stepActive==2" type="primary" @click="editSuccess" class="button">确定</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<script>
import { isvalidPass } from '@/assets/js/common'
import { sendCaptcha, getCaptcha, editEmail, addOrUpdateMember, oprateUser,updMemberName } from '@/api/index'
export default {
  // props: ['userInfo'],
  data() {
    let oldPass = sessionStorage.getItem('password')
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'));
      } else if (value != oldPass) {
        callback(new Error('原密码输入不正确'));
      } else {
        callback();
      }
    };
    var validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }
      // else if (value == this.addAdminForm.password) {
      //   callback(new Error('新密码和原密码不能一致哦!'))
      // }
      else if (!isvalidPass(value)) {
        callback(new Error('密码长度在6~18之间 包含字母和数字'))
      }
      else {
        if (this.editPasswordRuleForm.checkPass !== '') {
          this.$refs.editPasswordRuleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.editPasswordRuleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userInfo: null,
      roleType: sessionStorage.getItem('roleType'),
      email: sessionStorage.getItem('email'),
      memberInfo: JSON.parse(sessionStorage.getItem('memberInfo')),
      editInfoVisible: false,
      stepActive: 0,
      editInfoForm: {
        email: '',
        captcha: ''
      },
      editInfoRules: {
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      isDisable: false,
      timer: null,
      time: 120,
      newEmailForm: {
        email: '',
        newEmail: '',
        captcha: ''
      },
      newEmailRules: {
        newEmail: [{ required: true, message: '请输入新邮箱', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      passwordVisible: false,
      editPasswordRuleForm: {
        oldPassword: '',
        newPassword: '',
        checkPass: ''
      },
      editPasswordRules: {
        oldPassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validatePass1, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      editCompanyNameForm:{
        newCompanyName: ''
      },
      editCompanyNameRules:{
        newCompanyName: [{ required: true,message: '请输入新公司名', trigger: 'blur' }]
      },
      companyNameVisible:false,
      defaultImg: require('@/assets/img/avatar.png'),
      successImg: '',
      imageUrl: '',
      headerObj: { token: sessionStorage.getItem('token') },
      editParams: {
        id: '',
        logo: '',
      },
      delayTimer: null,
      meberImperfectNum:sessionStorage.getItem('meberImperfectNum')
    }
  },
  created() {
    this.imageUrl = this.$http.defaults.baseURL + 'user/uploadFile'
    this.init()
  },
  destroyed() {
    clearInterval(this.timer)
    clearInterval(this.delayTimer)
  },
  methods: {
    // 上传文件前校验
    beforeAvatarUpload(file) {
      // var FileExt = file.name.replace(/.+\./, "");
      // if (['zip', 'rar', 'gz', ".apk"].indexOf(FileExt.toLowerCase()) === -1) {
      //   this.activeColor = 'red'
      //   this.message = "文件格式有误，请重新上传!"
      //   return false;
      // } else if (file.size / 1024 / 1024 > 40) {
      //   this.activeColor = 'red'
      //   this.message = "文件大于100M，请重新上传!"
      // }
      // this.activeColor = '#999'
      // this.message = "上传中,请稍等..."
    },
    init() {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    },
    uploadFile() { },
    handleRemove(file, fileList) {
      this.successImg = ''
    },
    async handleSuccess(file) {
      if (file.code == 0) {
        this.successImg = file.fileUrl
        this.editParams.id = this.userInfo.id
        this.editParams.logo = this.successImg
        const { data } = await addOrUpdateMember(this.editParams)
        if (data.code == 0) {
          this.$parent.$parent.$parent.getBannerInfo()
          this.$parent.$parent.$parent.init()
          this.delayTimer = setTimeout(() => {
            this.init()
          }, 100);
        } else {
          this.$message.error(data.msg)
        }
      }
    },
    handlePreview(file) {
      this.successImg = file.fileUrl
    },
    closeeditInfoDialog() {
      this.stepActive = 0
      this.$refs.editInfoForm ? this.$refs.editInfoForm.resetFields() : '';
      this.$refs.newEmailForm ? this.$refs.newEmailForm.resetFields() : '';
    },
    async sendCode(email) {
      this.isDisable = true
      clearInterval(this.timer)
      const { data } = await sendCaptcha(email)
      if (data.code == 0) {
        this.timer = setInterval(() => {
          if (this.time < 1) {
            clearInterval(this.timer)
            this.isDisable = false
            this.time = 60
          } else {
            this.time -= 1
          }
        }, 1000);
      } else {
        this.$message.error(data.msg)
      }
    },
    next() {
      try {
        if (this.userInfo) {
          this.editInfoForm.email = this.userInfo.email
          this.$refs.editInfoForm.validate(async (valid) => {
            if (valid) {
              const { data } = await getCaptcha(this.editInfoForm)
              if (data.code !== 0) return
              this.stepActive = 1
              clearInterval(this.timer)
              this.isDisable = false
              this.time = 60
            }
          })
        }
      } catch (error) {
        this.message.error(error.data.msg)
      }
    },
    nextStep() {
      if (this.userInfo) {
        this.newEmailForm.email = this.userInfo.email
        this.$refs.newEmailForm.validate(async (valid) => {
          if (valid) {
            const { data } = await editEmail(this.newEmailForm)
            if (data.code == 0) {
              this.stepActive = 2
            } else {
              this.$message.error(data.msg)
              clearInterval(this.timer)
              this.isDisable = false
              this.time = 60
            }
          }
        })
      }
    },
    editSuccess() {
      this.editInfoVisible = false
      this.$parent.init()
    },
    goBackHome() {
      if (this.roleType == 2) {
        this.$router.push('/home/adminManagement')
      } else if (this.roleType == 3) {
        this.$router.push('/home/management')
      }
    },
    closeEditDialog() {
      this.$refs.editPasswordRuleForm.resetFields();
    },
    holdNewPassword(type, id) {
      this.$refs.editPasswordRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm('密码修改后需要重新登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async (res) => {
            if (res == 'confirm') {
              let param = {
                id: this.userInfo.userId,
                password: this.editPasswordRuleForm.newPassword
              }
              const { data } = await oprateUser(type, param)
              if (data.code != 0) return
              this.passwordVisible = false
              this.$router.push('/login')
              sessionStorage.clear()
            }

          }).catch(() => {
            console.log('取消修改');
          });

        }
      })
    },
    editEmailInfo() {
      this.editInfoVisible = true
      this.editInfoForm = {}
    },
    // 修改公司名
    holdNewCompanyName() {
      this.$refs.editCompanyNameForm.validate(async (valid) => {
        if (valid) {
          try {
              let param = {
                id: this.userInfo.id,
                memberUnitName: this.editCompanyNameForm.newCompanyName
              }
              const { data } = await updMemberName(param)
              if(data.code == '1' ){
                this.$message.success(data.msg)
                this.companyNameVisible = false
                this.$router.push('/home')
                location.reload()
              }else if(data.code == '2' ){
                this.$message.error(data.msg)
              }
          } catch (err) {
              if(err.data.code == '1' ){
                this.$message.success(err.data.msg)
                this.companyNameVisible = false
                this.$router.push('/home')
                location.reload()
              }else if(err.data.code == '2' ){
                this.$message.error(err.data.msg)
              }
          }
          
          
        }
      })
    }, 
    closeEditNameDialog() {
      this.$refs.editCompanyNameForm.resetFields();
    },
  }
}
</script>
<style lang='less' scoped>
/deep/.el-upload-list--picture .el-upload-list__item {
  display: none;
}
.uploadImg {
  margin-top: 85px !important;
  padding: 40px 0 50px 0;
  .defaultImg {
    height: 100px;
    width: 100px;
    border-radius: 10px;
    overflow: hidden;
    position: absolute;
    top: -50px;
    left: 0;
    background-color: #eee;
    box-sizing: border-box;
    margin-top: 10px;
    padding: 10px 10px 10px 90px;
    /deep/img {
      width: 100px;
    }
  }
  .defaultImg1 {
    height: 106px;
    width: 106px;
    border-radius: 10px;
    overflow: hidden;
    position: absolute;
    top: -50px;
    left: 0;
    background-color: #c0c4cc;
    box-sizing: border-box;
    margin-top: 10px;
    color: #fff;
    line-height: 106px;
    font-size: 50px;
  }
  /deep/.el-avatar > img {
    position: absolute;
    top: 0;
    left: 0;
    // width: 100%;
  }
  .upload {
    position: absolute;
    top: 0;
    left: 13%;
    .tips {
      display: inline-block;
      margin-left: 10px;
    }
    .add {
      width: 120px !important;
      display: inline-block;
      background-color: #0167cc;
    }
  }
}

#info {
  padding: 0 25px;
  .strong {
    font-weight: 550;
    color: #0dd0c0 !important;
  }
  .admin_content {
    // margin-top: 35px;
    .addNew {
      width: 120px;
    }
    .more {
      cursor: pointer;
    }
    .backHome {
      color: #1296db;
      font-size: 17px;
      width: 100px !important;
      cursor: pointer;
      img {
        width: 20px;
        margin-right: 5px;
        vertical-align: bottom;
      }
    }
    .detailInfo {
      font-size: 16px;
      margin-top: 35px;
      .titleName {
        font-weight: 550;
      }
      .titleContent {
        color: #666;
      }
      .titleContent.warning {
        font-weight: 550;
        color: #F56C6C;
      }
      img {
        cursor: pointer;
      }
    }
    .selectOprate {
      margin: 10px 0 20px;
      span {
        width: 150px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 16px;
        border: solid 1px #d9d9d9;
        cursor: pointer;
        color: #999999;
        display: inline-block;
        background-color: #f3f6f9;
      }
      .mine {
        border-radius: 3px 0 0 3px;
        border-right: none;
      }
      .other {
        border-radius: 0 3px 3px 0;
        border-left: none;
        margin-right: 31%;
      }
      .active {
        color: #fff;
        background: linear-gradient(-45deg, #286ac4 0%, #3793f4 100%);
      }
    }
  }
  .editPasswrd {
    .el-dialog__footer {
      .el-button {
        line-height: 0;
      }
    }
  }
  /deep/ .editInfoVisible {
    .el-dialog__body {
      padding: 30px 40px !important;
      .editInfoForm {
        color: #666;
        margin-top: 30px;
        .send {
          width: 130px;
          background-image: linear-gradient(260deg, #096bd0 0%, #209afd 100%);
          margin-left: 5px;
        }
      }
      .newEmailForm {
        .el-input {
          width: 56%;
        }
      }
      .code {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
    }
    .el-button {
      background-color: #286ac4;
      color: #fff;
      line-height: 0;
      width: 90px;
    }
    .nextSure {
      background-color: #fff;
      color: #0066cc;
    }
  }
}
</style>